import { render, staticRenderFns } from "./GainExportModal.vue?vue&type=template&id=8b0288b2&"
import script from "./GainExportModal.vue?vue&type=script&lang=js&"
export * from "./GainExportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports